import { displayDateText } from "@util/moment";
import { displayDateLength } from "@util/utils";

export const adaptMembershipChange = (raw = {}) => {
	const {
		itemID,
		rangeTypeText,
		itemTypeText,
		applyDate,
		startDate,
		endDate,
		rangeMonth,
		rangeDay,
		reasonText,
		employeeName,
		url,
		canDelete
	} = raw || {};

	const descList = [{ label: "申請日期", text: displayDateText(applyDate) }];
	const timelineMetainfo = [{ label: "期間", text: displayDateText(startDate, endDate, "") }];

	
	if (rangeMonth || rangeDay ) {
		// 加入 reasonText 拆行
		if (reasonText) {
			const lines = raw.reasonText.split(/\s+/g).map((line) => line.trim()).filter(Boolean);
			lines.forEach((text) => descList.push({ text }));
		}
		
		timelineMetainfo.push({ label: "天數", text: displayDateLength(rangeMonth, rangeDay) })

	}

	timelineMetainfo.push({ label: "擔當", text: employeeName });


	return (
		{
			id: itemID,
			type: "membership",
			title: rangeTypeText || itemTypeText,
			pdfUrl: url,
			canDelete,

			// 卡片主內容說明區塊
			descList: descList,

			// Timeline 上方額外顯示的 meta
			timelineMetainfo: timelineMetainfo
		}
	);
};
